
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button/Button';

import { useTranslation } from 'react-i18next';

const Alert = ({
    isOpen,
    title,
    message,
    onClose,
    type = 'info', // 'success', 'error', 'info', 'warning'
    style = {},
    overlayStyle = {}
}) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    const overlayStyles = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        backdropFilter: 'blur(5px)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 1, // You could add transition logic here if using a library, but inline is tricky for simple mount/unmount
        transition: 'opacity 0.2s ease-in-out',
        ...overlayStyle
    };

    const alertStyles = {
        background: 'rgba(30, 30, 30, 0.95)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '16px',
        padding: '24px',
        width: '90%',
        maxWidth: '400px',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        color: '#fff',
        textAlign: 'center',
        transform: 'translateY(0)', // Placeholder for animation start state
        animation: 'slideUp 0.3s ease-out',
        ...style
    };

    const getIcon = () => {
        switch (type) {
            case 'success': return '✅';
            case 'error': return '❌';
            case 'warning': return '⚠️';
            default: return 'ℹ️';
        }
    };

    return (
        <div style={overlayStyles} onClick={onClose} className="alert-overlay">
            <style>
                {`
                    @keyframes slideUp {
                        from { transform: translateY(20px); opacity: 0; }
                        to { transform: translateY(0); opacity: 1; }
                    }
                `}
            </style>
            <div
                style={alertStyles}
                onClick={(e) => e.stopPropagation()} // Prevent click from closing when clicking inside
                className="alert-content"
            >
                <div style={{ fontSize: '2rem', marginBottom: '8px' }}>
                    {getIcon()}
                </div>

                {title && (
                    <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '600' }}>
                        {title}
                    </h3>
                )}

                {message && (
                    <p style={{ margin: 0, fontSize: '1rem', color: '#ccc', lineHeight: '1.5' }}>
                        {message}
                    </p>
                )}

                <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'center' }}>
                    <Button
                        onClick={onClose}
                        variant={type === 'error' ? 'danger' : 'primary'}
                        size="medium"
                        style={{ minWidth: '120px' }}
                    >
                        {t('ok')}
                    </Button>
                </div>
            </div>
        </div>
    );
};

Alert.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    type: PropTypes.oneOf(['success', 'error', 'info', 'warning']),
    style: PropTypes.object,
    overlayStyle: PropTypes.object
};

export default Alert;
